let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7rtVM")).then(() => parcelRequire('7Td9S'));